import { z } from 'zod'

export const ModuleFrequency = z.enum([
  'MINUTES_15',
  'MINUTES_30',
  'MINUTES_45',
  'HOUR_1',
  'HOUR_1_MINUTES_15',
  'HOUR_1_MINUTES_30',
  'HOUR_1_MINUTES_45',
  'HOUR_2',
  'TIME_PER_DAY',
  'TIME_PER_SESSION'
])
export type ModuleFrequency = z.infer<typeof ModuleFrequency>

export const ModuleFrequencyNullable = ModuleFrequency.nullable()
export type ModuleFrequencyNullable = z.infer<typeof ModuleFrequencyNullable>
